import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageBoxIcon, MessageBoxResult } from 'src/app/messagebox/messagebox.model';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { ReferralDeferralResponse, ViewReferralConfirmationInjectData } from '../referrals.model';

@Component({
    selector: 'app-dialog-view-referral-confirmation',
    templateUrl: './dialog-view-referral-confirmation.component.html',
    styleUrls: ['./dialog-view-referral-confirmation.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DialogViewReferralConfirmationComponent {
    title: string;
    message: string;
    icon: MessageBoxIcon;
    showInput: boolean;
    buttonTextForConfirm: string;
    inputReasonForDeferral = new UntypedFormControl(null, [Validators.required, CustomValidators.noWhitespaceValidator]);

    MessageBoxIcon = MessageBoxIcon;

    constructor(
        public dialogRef: MatDialogRef<DialogViewReferralConfirmationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ViewReferralConfirmationInjectData
    ) {
        this.title = data.title;
        this.message = data.message;
        this.icon = data.icon;
        this.showInput = data.showInput;
        this.buttonTextForConfirm = data.buttonTextForConfirm;
        this.dialogRef.disableClose = true;

        if (!data.showInput) {
            this.inputReasonForDeferral.disable();
        }
    }

    confirmDeferral() {
        if (!this.inputReasonForDeferral.invalid) {
            // when field is disabled, valid will always be false
            this.dialogRef.close(
                new ReferralDeferralResponse({
                    result: MessageBoxResult.Yes,
                    body: this.inputReasonForDeferral.value
                })
            );
        } else {
            this.inputReasonForDeferral.markAsDirty();
        }
    }

    close() {
        this.dialogRef.close(
            new ReferralDeferralResponse({
                result: MessageBoxResult.No
            })
        );
    }
}
